<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { useVModel } from '@vueuse/core';
import { cn } from '@/lib/utils';

const props = defineProps<{
  class?: HTMLAttributes['class'];
  defaultValue?: string | number;
  modelValue?: string | number;
}>();

const emits = defineEmits<{
  (e: 'update:modelValue', payload: string | number): void;
}>();

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
});
</script>

<template>
  <textarea
    v-model="modelValue"
    :class="
      cn(
        'tw-flex tw-min-h-[60px] tw-w-full tw-rounded-md tw-border tw-border-neutral-200 tw-bg-transparent tw-px-3 tw-py-2 tw-text-sm tw-shadow-sm placeholder:tw-text-neutral-500 focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-neutral-950 disabled:tw-cursor-not-allowed disabled:tw-opacity-50 dark:tw-border-neutral-800 dark:placeholder:tw-text-neutral-400 dark:focus-visible:tw-ring-neutral-300',
        props.class
      )
    "
  />
</template>
